import { Spacing } from '@doordash/design-language'
import styled from 'styled-components'

export const CloseButton = styled.div`
  position: absolute;
  left: ${Spacing.Medium}px;
  top: ${Spacing.Medium}px;
`

export const Content = styled.div`
  margin-top: ${Spacing.XLarge}px;
`
